import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Link,
  Checkbox,
  FormControlLabel,
  Modal,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Register: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [consent, setConsent] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const handleEmailSubmit = () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      setEmailError("Email is not valid.");
    } else {
      setEmailError("");
    }
  };

  const handleRegister = () => {
    setEmailError(""); // Reset email error
    setPasswordError(""); // Reset password error

    // Validate email
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      setEmailError("Email is not valid.");
      return;
    }

    // Validate password
    if (!password) {
      setPasswordError("Password is required.");
    } else if (password.length < 8) {
      setPasswordError("Password must be at least 8 characters.");
    } else if (!consent) {
      alert("You must accept the consent.");
    } else {
      console.log("Registering with", email, password);
      // Implement your registration logic here
    }
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="background.default"
      padding={2}
    >
      <img
        src={`${process.env.PUBLIC_URL}/tat_logo.png`}
        alt="Logo"
        style={{ width: 80, height: 80, marginBottom: "32px" }} // Adjust size as needed
      />
      <Typography variant="h5" color="textPrimary" gutterBottom>
        ลงทะเบียน
      </Typography>
      <Box width="100%" maxWidth={400}>
        <TextField
          label="Email address"
          type="email"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          error={!!emailError}
          helperText={emailError}
          autoComplete="username"
          margin="normal"
          onBlur={handleEmailSubmit} // Validate email on blur
        />
        <TextField
          label="รหัสผ่าน"
          type="password"
          variant="outlined"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
          margin="normal"
          error={!!passwordError}
          helperText={passwordError}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={consent}
              onChange={(e) => setConsent(e.target.checked)}
              color="primary"
            />
          }
          label={
            <>
              <Typography variant="body2" color="textPrimary" component="span">
                {" "}
                {/* Adjust font size here */}
                ฉันยอมรับ{" "}
                <Link
                  onClick={handleOpenModal}
                  underline="hover"
                  style={{ cursor: "pointer" }}
                >
                  เงื่อนไขและข้อกำหนด
                </Link>
              </Typography>
            </>
          }
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleRegister}
          fullWidth
          sx={{ mt: 2, height: "56px" }} // Adjust font size here
        >
          ลงทะเบียน
        </Button>
        <Typography
          variant="body2"
          color="textPrimary"
          sx={{ mt: 2, textAlign: "center" }}
        >
          {" "}
          {/* Adjust font size here */}
          มีบัญชีผู้ใช้งานแล้ว?{" "}
          <Link href="/login" underline="hover">
            เข้าสู่ระบบ
          </Link>
        </Typography>
      </Box>

      {/* Modal for Consent Terms */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: "400px",
            borderRadius: "8px",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography id="modal-title" variant="h6" component="h2">
            เงื่อนไขและข้อกำหนด
          </Typography>
          <Box
            sx={{
              maxHeight: "60vh",
              overflowY: "auto",
              mt: 2,
              mb: 2,
            }}
          >
            <Typography id="modal-description">
              นี่คือเงื่อนไขและข้อกำหนดที่คุณต้องยอมรับเพื่อดำเนินการต่อ
              โดยมีเนื้อหาที่ยาวมากจนทำให้คุณต้องเลื่อนลงเพื่ออ่านทั้งหมด
              ตัวอย่างของเนื้อหาอาจรวมถึง:
              {/* Example of long text */}
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
              {/* Repeat or expand this text to ensure it exceeds the viewport height */}
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
            </Typography>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Register;
